/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.settings.integration.logs.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.api',
  'acme.common.service.userPreferences',
  'acme.common.service.themesHelper',
  'acme.view.application.settings.integration.logs.modals.view.controllers'
])

.controller('SettingsIntegrationLogsController', [
  '$scope', 
  '$state',
  '$filter',
  '$timeout',
  '$uibModal',
  'GridStateFactory',
  'GridDefinitionFactory',
  'ApiService',
  'UserPreferencesService',
  'ThemesHelperService',
  function(
    $scope,
    $state,
    $filter,
    $timeout,
    $uibModal,
    GridStateFactory,
    GridDefinitionFactory,
    ApiService,
    UserPreferencesService,
    ThemesHelperService
  ) {

    $scope.settingsIntegrationLogs = {

      model: [],
      
      formObject: {
        objectType: false,
        targetSystem: false,
        logId: ''
      },

      objectTypeList: [
        {
          id: 'select',
          name: '--Select Object--',
          label: '--Select Object--'
        },
        { 
          id: 'Address',
          name: 'Address',
          label: 'Address'
        },
        { 
          id: 'Customer',
          name: 'Customer',
          label: 'Customer'
        },
        { 
          id: 'DeleteNotification',
          name: 'Delete Notification',
          label: 'Delete Notification'
        },
        { 
          id: 'Household',
          name: 'Household',
          label: 'Household'
        },
        { 
          id: 'Membership',
          name: 'Membership',
          label: 'Membership'
        },
        { 
          id: 'MembershipBulk',
          name: 'Membership Import',
          label: 'Membership Import'
        },
        { 
          id: 'Order',
          name: 'Orders',
          label: 'Orders'
        },
        { 
          id: 'Organization',
          name: 'Organization',
          label: 'Organization'
        },
        {
          id: 'Contact',
          name: 'Organization Contact',
          label: 'Organization Contact'
        }
      ],

      targetSystemListBase: [
        { 
          id: '',
          name: 'ACME + Salesforce',
          label: 'ACME + Salesforce'
        },
        { 
          id: 'b2b',
          name: 'ACME Only',
          label: 'ACME Only'
        },
        { 
          id: 'sfdc',
          name: 'Salesforce Only',
          label: 'Salesforce Only'
        },
      ],

      targetSystemList: [],

      initialState: true,
      loadingLogs: false,

      // Grid state
      state: $state,
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      gridName: $state.current.name+'.grid-0',
      viewId: $state.current.name,
      dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),
      optionsOverride: {
        data: 'settingsIntegrationLogs.model',
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.settingsIntegrationLogs.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns, page) {
            $scope.settingsIntegrationLogs.onDataGridSortChange(grid, columns, page);
          },
          onDblClick: function(item) {
            $scope.settingsIntegrationLogs.onDblClick(item.entity);
          }
        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'Data Log ID'
          },
          {
            field: 'operationParsed',
            displayName: 'type'
          },
          {
            field: 'responseStatusCodeParsed',
            displayName: 'Response Status (Code)'
          },
          {
            field: 'targetSystemParsed',
            displayName: 'Target System'
          },
          {
            field: 'createdDateParsed',
            displayName: 'Processed Date'
          },
          {
            field: 'messageIdDateParsed',
            displayName: 'Creation Date',
            visible: false
          },
          {
            field: 'view',
            displayName: 'View',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.settingsIntegrationLogs.optionsOverride.appScopeProvider.onDblClick(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.orderNumber }}</span></a></div>',
            template: '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a>View</a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false
          },
        ]
      },

      init: function() {
        this.targetSystemList = angular.copy(this.targetSystemListBase);
        this.formObject.targetSystem = this.targetSystemList[0];
        this.formObject.objectType = this.objectTypeList[0];

        this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, this.state.current.data.enablePreferences);

        $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
      },


      initData: function(e, data) {
        var self = $scope.settingsIntegrationLogs, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
      },

      disableSearchLogsButton: function() {
        return (
          this.loadingLogs ||
          !this.formObject.objectType || 
          this.formObject.objectType.id === 'select' ||
          !this.formObject.logId
        );
      },

      search: function() {
        this.initialState = false;
        this.searchLogs();
      },

      searchLogs: function() {

        var props = {
          operation: this.formObject.objectType.id,
          target: this.formObject.targetSystem.id,
          objectId: this.formObject.logId
        };

        if(!this.initialState) {
          this.loadingLogs = true;
          this.hasError = false;
  
          ApiService.sfdc.logs.list($.extend(props, this.gridState.getGridState())).then(this.success.searchLogs, this.error.searchLogs);
        }
      },

      viewItem: function(item) {
        var self = $scope.settingsIntegrationLogs;

        $uibModal.open({
          size: 'lg',
          controller: 'SettingsIntegrationLogsModalsViewController',
          templateUrl: 'views/application/views/settings/integration/logs/modals/view/view.tpl.html',
          resolve: {
            formObjectData: function() {
              return self.formObject;
            },
            itemData: function() {
              return item;
            }
          }
        });
      },

      processResponse: function(res){
        return res.map(function(item) {
          var dateTime = new Date(item.createdOn);
          var startTime = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), dateTime.getHours(), dateTime.getMinutes());
          var messageIdDateArray = (item.messageId) ? item.messageId.split('_') : [];
          var messageIdDateTime = {};
          var messageIdStartTime = {};

          item.createdDateParsed = $filter('date')(startTime, $scope.settingsIntegrationLogs.dateTimeFormat);

          if (messageIdDateArray.length && moment(messageIdDateArray[0]).isValid()) {
            messageIdDateTime = new Date(item.createdOn);
            messageIdStartTime = moment.tz([messageIdDateTime.getFullYear(), messageIdDateTime.getMonth(), messageIdDateTime.getDate(), messageIdDateTime.getHours(), messageIdDateTime.getMinutes()], ThemesHelperService.getCompany('timezone')).format();

            item.messageIdDateParsed = $filter('date')(messageIdStartTime, $scope.settingsIntegrationLogs.dateTimeFormat);
          } else {
            item.messageIdDateParsed = false;
          }

          item.operationParsed = item.operation.split(/(?=[A-Z])/).join(' ');

          switch (item.target) {
            case 'b2b': 
              item.targetSystemParsed = 'ACME';
              break;
            case 'sfdc':
              item.targetSystemParsed = 'Salesforce';
              break;
            default:
              item.targetSystemParsed = targetSystem;
              break;
          }

          item.responseStatusCodeParsed = (item.error) ? 'Error (' + item.responseStatusCode + ')' : 'Success (' + item.responseStatusCode + ')';

          return item;
        });
      },

      success: {
        init: function(response) {},
        searchLogs: function(res) {
          var self = $scope.settingsIntegrationLogs;
          self.loadingLogs = false;

          self.model = self.processResponse(res.data.payload.list);
          self.gridDefinition.isLoaded = true;

          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: self.gridDefinition.options.gridName, 
              datasetLength: self.model.length, 
              totalItems: res.data.payload.pagination.count
            });
          }, 10);
        }
      },

      error: {
        init: function(response) {},
        searchLogs: function(res) {
          var self = $scope.settingsIntegrationLogs;
          self.loadingLogs = false;
          self.hasError = true;
        }
      },

      onDblClick: function(item) {
        var self = $scope.settingsIntegrationLogs;
        self.viewItem(item);
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.settingsIntegrationLogs;
        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if(sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.searchLogs();
      },

      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.settingsIntegrationLogs, data = columns[0];
        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
        self.searchLogs();
      },

    };

    $scope.settingsIntegrationLogs.init();

}]);